import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { UserProvider } from '../../providers/user/user.provider';
import { UserPage } from '../user/user';

/**
 * Generated class for the EventUsersPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-event-users',
  templateUrl: 'event-users.html',
})
export class EventUsersPage {
  users_keys: any = [];
  users: any = [];
  users_list: any = [];
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    private userProvider: UserProvider
  ) {
    this.users_list = this.navParams.get('users');
    // this.users_keys = Object.keys(this.users);
    // console.log("this.users", this.users);
    // console.log("this.users_keys", this.users_keys);
  }


  ionViewDidEnter() {
    console.log('ionViewDidLoad EventUsersPage');
    this.refresh();
  }

  async refresh(){
    await this.loadUsers();
  }

  async loadUsers() {
    let users = [];
    for (let user of this.users_list) {
      // console.log("loadUsers user", user);
      users.push(await this.userProvider.getUser(user));
        // console.log("result",result);
    }

    this.users = users;
    console.log("this.users", this.users);
  }

  goToUser(user){
    console.log("goToUser", user);
    this.navCtrl.push(UserPage, {user : user})
  }
}


// WEBPACK FOOTER //
// ./src/pages/event-users/event-users.ts